export const SMALL = 'small';
export const MEDIUM = 'medium';
export const LARGE = 'large';
export const FULL_WIDTH = 'full-width';

export const LEFT = 'left';
export const RIGHT = 'right';
export const CENTER = 'center';
export const TOP = 'top';
